/* eslint-disable jsx-a11y/anchor-is-valid */
import * as React from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import ViewListIcon from '@mui/icons-material/ViewList';
import Divider from '@mui/material/Divider';

import { Context } from "../Provider";

export default function FilterMenu() {
    const context = React.useContext(Context);

    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    // Split stages into groups
    const inProgress = context.state.ftm_stages.filter(
        (stage) => stage.ftm_stage_is_in_progress_flow === 1
    );

    const notInProgress = context.state.ftm_stages.filter(
        (stage) => stage.ftm_stage_is_in_progress_flow === 0
    );

    return (
        <React.Fragment>
            <div className="my-auto text-end">
                <div className="dropdown  pe-4">
                    <a className="text-white cursor-pointer" onClick={handleClick}>
                        <FilterAltIcon />
                    </a>
                </div>
            </div>

            <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
                <MenuItem
                    onClick={() => {
                        handleClose();
                        context.dispatch({
                            type: "SET_FILTER_OPTION",
                            filter_option: 0
                        });
                    }}
                >
                    <ListItemIcon>
                        <ViewListIcon fontSize="small" />
                    </ListItemIcon>
                    ALL
                </MenuItem>

                {/* In-progress stages */}
                {inProgress.map((ftm_stage, index) => (
                    ftm_stage.ftm_stage_is_in_progress_flow === 1 && (
                        <MenuItem
                            key={index}
                            onClick={() => {
                                handleClose();
                                context.dispatch({
                                    type: "SET_FILTER_OPTION",
                                    filter_option: ftm_stage.ftm_stage_id,
                                    is_date_search: ftm_stage.ftm_stage_name === "Tracker installed" || ftm_stage.ftm_stage_name === "Tracker send"
                                });
                            }}
                            sx={{ textTransform: "uppercase" }}
                        >
                            <ListItemIcon>
                                <i className="material-icons opacity-10">{ftm_stage.ftm_stage_icon}</i>
                            </ListItemIcon>
                            {ftm_stage.ftm_stage_name}
                        </MenuItem>
                    )
                ))}

                {/* Divider if notInProgress exists */}
                {notInProgress.length > 0 && <Divider sx={{ backgroundColor: '#b7b2b2', my: 1 }} />}

                {/* Not-in-progress stages */}
                {notInProgress.map((ftm_stage, index) => (
                    <MenuItem
                        key={`not-${index}`}
                        onClick={() => {
                            handleClose();
                            context.dispatch({
                                type: "SET_FILTER_OPTION",
                                filter_option: ftm_stage.ftm_stage_id,
                                is_date_search:
                                    ftm_stage.ftm_stage_name === "Tracker installed" ||
                                    ftm_stage.ftm_stage_name === "Tracker send"
                            });
                        }}
                        sx={{ textTransform: "uppercase" }}
                    >
                        <ListItemIcon>
                            <i className="material-icons opacity-10">{ftm_stage.ftm_stage_icon}</i>
                        </ListItemIcon>
                        {ftm_stage.ftm_stage_name}
                    </MenuItem>
                ))}
            </Menu>
        </React.Fragment>
    );
}